// extracted by mini-css-extract-plugin
export default {"imageWrapper":"sR-z","hovered":"tR-z","hoverImage":"uR-z","mainImage":"vR-z","imageNoBackground":"wR-z","fullSizeImage":"xR-z"};